import React, {
  createContext,
  useContext,
  useEffect,
  useState,
} from 'react';
import PropTypes from 'prop-types';

import { getCategoriesPerPage } from '../../../requests/api/category';

const CategoryOptionsContext = createContext([]);

function CategoryOptionsProvider({ children }) {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    let mounted = true;

    const loadCategories = async () => {
      const response = await getCategoriesPerPage(0, 1000, '', null);
      if (!mounted) return;

      const categoryList = response.success
        ? response.data?.data?.categories || []
        : [];
      setCategories([...categoryList].sort((a, b) => (
        a.name.localeCompare(b.name)
      )));
    };

    loadCategories();

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <CategoryOptionsContext.Provider value={categories}>
      {children}
    </CategoryOptionsContext.Provider>
  );
}

CategoryOptionsProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

const useCategoryOptions = () => useContext(CategoryOptionsContext);

export { CategoryOptionsProvider, useCategoryOptions };
